import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import msgConstants from '../../../../constants/msgConstants'
import ordemPagamentoManager from '../../../../services/api/ordemPagamento/ordemPagamentoManager'
import { FormValuesBuscarOPs } from '../../../../types/iniciarNovoCicloTypes'
import { OPPorPedidoResponse, OrdemPagamentoBuscarResponse } from '../../../../types/regularizacaoOPsTitulosTypes'
import { formatarData } from '../../../../utils/stringUtils'
import { modalVincularOPStyles } from './ModalVincularOP.styles'
import { ModalVincularOPProps } from './ModalVincularOP.View'

const mesmaOp = (op: OrdemPagamentoBuscarResponse, opPedido: OPPorPedidoResponse) =>
  op.ordemPagamentoId == opPedido.ordemPagamentoId &&
  op.bancoId == opPedido.banco &&
  op.operacaoOrdemPagamentoId == opPedido.operacaoOrdemPagamentoId &&
  String(op.dataEmissao).substring(0, 10) == String(opPedido.dataEmissao).substring(0, 10)

export function modalVincularOPIO({ opsPedido, incluirOps, fecharModal }: ModalVincularOPProps) {
  const { control, handleSubmit, reset } = useForm<FormValuesBuscarOPs>({})
  const [resultado, setResultado] = useState<OrdemPagamentoBuscarResponse[]>([])
  const [selecionadas, setSelecionadas] = useState<OrdemPagamentoBuscarResponse[]>([])
  const [loading, setLoading] = useState(false)

  const vinculadaCiclo = (op: OrdemPagamentoBuscarResponse) => !!op.cicloId && Number(op.cicloId) !== 0

  const jaIncluida = (op: OrdemPagamentoBuscarResponse) => opsPedido.some((opPedido) => mesmaOp(op, opPedido))

  // OP vinculada a um ciclo ativo não pode ser consumida aqui, senão o ciclo e a regularização usariam a mesma OP
  const disponivel = (op: OrdemPagamentoBuscarResponse) => !vinculadaCiclo(op) && !jaIncluida(op)

  const buscarOps = async (data: FormValuesBuscarOPs) => {
    setLoading(true)
    setSelecionadas([])
    ordemPagamentoManager
      .buscarOps(data)
      .then((response) => {
        const ops = (response as unknown) as OrdemPagamentoBuscarResponse[]
        setResultado(ops ?? [])
        if (!ops || ops.length == 0) {
          toast.warning(msgConstants.REGULARIZACAO.opNaoEncontrada)
        } else if (!ops.some(disponivel)) {
          toast.warning(msgConstants.REGULARIZACAO.opIndisponivel)
        }
      })
      .catch((e: Error) => {
        toast.error(e.message)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleCheckbox = (event: React.ChangeEvent<HTMLInputElement>, op: OrdemPagamentoBuscarResponse) => {
    if (event.target.checked) {
      if (disponivel(op)) setSelecionadas([...selecionadas, op])
    } else {
      setSelecionadas(selecionadas.filter((selecionada) => selecionada !== op))
    }
  }

  const handleSelecionarTodas = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.checked ? setSelecionadas(resultado.filter(disponivel)) : setSelecionadas([])
  }

  const isSelecionada = (op: OrdemPagamentoBuscarResponse) => selecionadas.includes(op)

  const limparDadosModal = () => {
    reset()
    setResultado([])
    setSelecionadas([])
    fecharModal()
  }

  const handleIncluir = () => {
    incluirOps(
      selecionadas.map((op) => ({
        operacaoOrdemPagamentoId: op.operacaoOrdemPagamentoId,
        ordemPagamentoId: op.ordemPagamentoId,
        banco: op.bancoId,
        emitente: op.emitente,
        descricaoPagamento: op.descricao,
        dataEmissao: op.dataEmissao,
        valor: op.valorPagamento
      }))
    )
    toast.success(msgConstants.REGULARIZACAO.opIncluida)
    limparDadosModal()
  }

  return {
    styles: modalVincularOPStyles,
    control,
    handleSubmit,
    buscarOps,
    loading,
    resultado,
    selecionadas,
    handleCheckbox,
    handleSelecionarTodas,
    isSelecionada,
    vinculadaCiclo,
    jaIncluida,
    disponivel,
    handleIncluir,
    limparDadosModal,
    dataAtualPadrao: String(formatarData(new Date().toISOString(), '-'))
  }
}

export type ModalVincularOPIO = ReturnType<typeof modalVincularOPIO>
